export default __webpack_public_path__ + "static/media/education.4cd1743d.svg";